import React from 'react';
import Header from '../common/Header';
import Footer from '../common/Footer';
import useTitle from '../../hooks/useTitle';
 
const Layout = ({ children, title }) => {
  useTitle(title);

  return (
    <>
      <main className="main" id="top">
        <Header />
        <div className="content">
          {children}
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Layout;
